import { z } from 'zod';
/** Entrada no mensageiro: token de uso único emitido pela API para o login no homeserver. */
export const messagingSessionSchema = z.object({
    serverName: z.string().min(1),
    homeserverUrl: z.url(),
    userId: z.string().regex(/^@[a-z0-9._=\-/]+:.+$/),
    deviceId: z.string().min(1),
    token: z.string().min(16),
    expiresAt: z.iso.datetime(),
});
